<template>
  <transition name="fade">
    <header class="site-page landing-header" v-if="!loading">
      <!--Navbar-->
      <b-navbar id="nav" toggleable="lg" type="dark" fixed="top">
        <b-container>
          <b-navbar-brand>
            <router-link to="/">
              <img
                src="@/assets/img/logo/boxx-mini-black.svg"
                alt="BOXX Barber Shop logo"
                height="24"
              />
            </router-link>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Left aligned nav items -->
            <b-navbar-nav></b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <!-- <router-link tag="b-nav-item" to="/">Home</router-link> -->
              <b-nav-item
                v-scroll-to="{ el: '#our-story', offset: -200 }"
                @click.prevent="setUrlHash('#our-story')"
              >
                Our Story
              </b-nav-item>
              <b-nav-item
                v-scroll-to="{ el: '#locations', offset: -200 }"
                @click.prevent="setUrlHash('#locations')"
              >
                Locations
              </b-nav-item>
              <router-link tag="b-nav-item" :to="{ name: 'book' }">
                Book Now
              </router-link>
            </b-navbar-nav>
          </b-collapse>
        </b-container>
      </b-navbar>
    </header>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('scroll', function() {
        var navbar = document.getElementById('nav');
        var nav_classes = navbar.classList;
        if (document.documentElement.scrollTop >= 150) {
          if (nav_classes.contains('scroll') === false) {
            nav_classes.toggle('scroll');
          }
        } else {
          if (nav_classes.contains('scroll') === true) {
            nav_classes.toggle('scroll');
          }
        }
      });
    });
  },
  created() {
    setTimeout(() => (this.loading = false), 300);
  }
};
</script>
